import type { User } from '@firebase/auth'

import { proxy, useSnapshot } from 'valtio'
import { devtools } from 'valtio/utils'

type UserStore = {
  userId: User['uid']
}

export const userStore = proxy<UserStore>({
  userId: '',
})

// Devtools
devtools(userStore, { name: 'userStore', enabled: true })

export function useUserStore() {
  return useSnapshot(userStore)
}
